import React from "react";

function HumidifierIcon({ style }: any) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M8.25 6.75C6.5925 6.75 5.25 8.0925 5.25 9.75C5.25 11.4075 6.5925 12.75 8.25 12.75C9.9075 12.75 11.25 11.4075 11.25 9.75C11.25 8.0925 9.9075 6.75 8.25 6.75ZM8.25 11.25C7.425 11.25 6.75 10.5825 6.75 9.75C6.75 8.9175 7.425 8.25 8.25 8.25C9.075 8.25 9.75 8.925 9.75 9.75C9.75 10.575 9.0825 11.25 8.25 11.25ZM5.25 3H10.5C12.1575 3 13.5 4.3425 13.5 6V6.75H12V6C12 5.60218 11.842 5.22064 11.5607 4.93934C11.2794 4.65804 10.8978 4.5 10.5 4.5H5.25C4.425 4.5 3.75 5.175 3.75 6V15H12V13.5H13.5V16.5H2.25V6C2.25 4.3425 3.5925 3 5.25 3ZM14.25 7.875C14.25 7.875 15.75 9.5025 15.75 10.5C15.75 11.325 15.075 12 14.25 12C13.425 12 12.75 11.325 12.75 10.5C12.75 9.5025 14.25 7.875 14.25 7.875Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default HumidifierIcon;
